import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/icons/audio-file-icon.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		id: "Layer_1",
		enableBackground: "new 0 0 28 28",
		height: "512",
		viewBox: "0 0 28 28",
		width: "512",
		xmlns: "http://www.w3.org/2000/svg",
		...t,
		children: /* @__PURE__ */ e("g", {
			id: "_x35_3",
			children: /* @__PURE__ */ e("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" })
		})
	});
}
//#endregion
export { t as default };
